import { Outlet, createFileRoute, useLocation } from '@tanstack/react-router';
import { MobileDeviceNotice } from '~/components/layout';
import { Typography } from '~/components/ui';
import { useIsMobile } from '~/hooks';
import { cn } from '~/lib/utils';

export const Route = createFileRoute('/_auth')({
	component: AuthLayout,
});

function AuthLayout() {
	const location = useLocation();
	const isSamtek = location.pathname.includes('/samtek');
	const isMobile = useIsMobile();
	return (
		<div
			className={cn(
				'relative min-h-svh',
				!isSamtek && 'bg-default-50',
				isMobile && 'bg-linear-to-br from-[#ea580c] via-[#f59e0b] to-[#ea580c]',
			)}
		>
			<MobileDeviceNotice />
			<div className="flex flex-col lg:flex-row min-h-svh relative items-center p-5 justify-center md:p-10 gap-2.5 lg:gap-5 h-[calc(100svh-50px)]">
				<div
					className="w-full hidden lg:flex flex-col justify-end text-white h-full bg-cover bg-bottom bg-no-repeat overflow-hidden rounded-lg sm:rounded-3xl shadow-2xl lg:px-16 2xl:px-30 lg:py-30 2xl:py-40"
					style={{ backgroundImage: "url('/images/bg-login2.png')" }}
				>
					<Typography variant="paragraphl" className="lg:text-[50px] 2xl:text-[60px] leading-none">
						Welcome to
					</Typography>
					<Typography
						variant="paragraphl"
						className="lg:text-[90px] 2xl:text-[110px] leading-none mb-16 font-bold"
					>
						SAMTEK ONE
					</Typography>
					<Typography variant="body" className="lg:text-[24px] text-[16px] font-light">
						Nơi công nghệ đồng hành cùng mọi bước tiến thành công của doanh nghiệp
					</Typography>
				</div>
				<div className="w-full lg:w-1/2 2xl:w-187.5 flex flex-col justify-center bg-white overflow-hidden rounded-lg sm:rounded-3xl shadow-2xl h-auto lg:h-full relative py-10 lg:py-0">
					<Outlet />
				</div>
			</div>
		</div>
	);
}
